/**
 * LoginService
 * @module client/src/app/shared/services
 */
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { selectSessionState } from '@rpt-ngrx/selectors/session.selector';
import { IUserSession } from '@shared/types/session';

/**
 * # LoginService
 * Defines the service for establishing if user is logged in
 */
@Injectable()
export class LoginService {
    /**
     * Initialize the service
     * Services need initialization in the constructor.
     */
    constructor(private store: Store) {}

    /**
     * This getter returns the observable which provides the value
     * for understanding if user is logged in
     */
    public get isLoggedIn(): Observable<boolean> {
        return this.store.select(selectSessionState).pipe(
            filter((userSession: IUserSession) => userSession !== null && userSession !== undefined),
            map((userSession: IUserSession) => !!userSession.token),
        );
    }
}
